<template>
  <div>
    <DashboardHeader title="SMS Dashboard">
      <BulkSMSComponent>
        <template #SendSMS="{recipientsObjArray}">
          <sendSMS
            :recipientsObjArray="recipientsObjArray"
            class="mx-4"
          ></sendSMS>
        </template>

        <template
          #MembersList="{selectedMembers, getSelectedMembers, openAddNewMemberDialog}"
        >
          <MembersList
            :selectedMembers="selectedMembers"
            @selected-members="getSelectedMembers"
            @open-add-new-member-dialog="openAddNewMemberDialog"
          ></MembersList>
        </template>
      </BulkSMSComponent>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import SendSMS from "./SendSMS";
import MembersList from "./MembersList";

import BulkSMSComponent from "baron-vue-bulk-sms-component";
//import BulkSMSComponent from "../../../../baron-vue-bulk-sms-component/src/App.vue";

export default {
  components: {
    DashboardHeader,
    BulkSMSComponent,
    SendSMS,
    MembersList,
  },
};
</script>

<style></style>
